export default "__VITE_ASSET__Bny1Axpv__"